import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Link2, Target } from 'lucide-react';
export function PhilosophySection() {
  const principles = [{
    icon: <Eye size={32} data-id="element-180" />,
    title: 'Observe deeply'
  }, {
    icon: <Link2 size={32} data-id="element-181" />,
    title: 'Connect meaningfully'
  }, {
    icon: <Target size={32} data-id="element-182" />,
    title: 'Act intentionally'
  }];
  return <section className="py-24 bg-teal-900 text-white relative overflow-hidden" data-id="element-183">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-teal-800 rounded-full opacity-50 blur-3xl" data-id="element-184"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-185">
        <div className="text-center max-w-4xl mx-auto" data-id="element-186">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-187">
            Innovation doesn't start with ideas. <br data-id="element-188" />
            <span className="text-amber-400" data-id="element-189">
              It starts with conversations.
            </span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-teal-100 mb-16" data-id="element-190">
            At Latteware, we practice{' '}
            <span className="font-bold text-white" data-id="element-191">InnovArte</span>. We create
            inflection points—moments where clarity emerges and lives change
            direction.
          </motion.p>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-192">
            {principles.map((principle, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3 + idx * 0.1
          }} className="bg-teal-800/50 backdrop-blur-sm p-8 rounded-xl border border-teal-700/50 flex flex-col items-center" data-id="element-193">
                <div className="text-amber-400 mb-4" data-id="element-194">{principle.icon}</div>
                <h3 className="text-xl font-bold" data-id="element-195">{principle.title}</h3>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}